import { useEffect, useRef } from "react";

/**
 * Custom hook to scroll an element into view when a key changes
 * @param key - The current selected key (e.g., index or id)
 * @returns ref object to attach to elements
 */
export function useScrollIntoView<T extends HTMLElement>(key: string | number | null) {
  const refs = useRef<{ [key: string]: T | null }>({});

  useEffect(() => {
    if (key !== null && key !== undefined && refs.current[key]) {
      refs.current[key]?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [key]);

  return refs;
}
